// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"7424455f","732":"83948f92"}[chunkId] + ".chunk.js";
};